import { Component, EventEmitter, Input, Output } from '@angular/core';
import { businessAreas } from 'backend/interfaces/business-areas';
import { CatalogueItem } from 'backend/interfaces/community-groups';

@Component({
  selector: 'app-community-area-select',
  template: `
    <mat-form-field appearance="fill" class="area-search">
      <mat-label>Search areas</mat-label>
      <input #searchInput matInput aria-label="Search areas" [value]="search"
        (input)="search = $any($event.target).value" [matAutocomplete]="areaOptions"
        (keydown.enter)="$event.preventDefault()">
      <mat-autocomplete #areaOptions="matAutocomplete" (optionSelected)="add($event.option.value); searchInput.value = ''">
        <mat-option *ngFor="let area of options" [value]="area.id">{{ area.name }} — {{ area.province }}</mat-option>
        <mat-option *ngIf="!options.length" disabled>No matching areas</mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <ul aria-label="Selected areas">
      <li *ngFor="let area of selection">
        {{ area.name }}
        <button mat-button type="button" (click)="remove(area.id)" [attr.aria-label]="'Remove ' + area.name">Remove</button>
      </li>
    </ul>
  `,
  styles: ['.area-search { width: 100%; } ul { padding-left: 20px; }']
})
export class CommunityAreaSelectComponent {
  @Input() selection: CatalogueItem[] = [];
  @Output() selectionChange = new EventEmitter<CatalogueItem[]>();
  search = '';
  get options() {
    const query = this.search.trim().toLocaleLowerCase();
    return businessAreas.filter(area => !this.selection.some(selected => selected.id === area.id) &&
      (area.name.toLocaleLowerCase().includes(query) || area.province.toLocaleLowerCase().includes(query)));
  }
  add(id: string): void {
    const area = businessAreas.find(item => item.id === id);
    if (area && !this.selection.some(item => item.id === id)) {
      this.selectionChange.emit([...this.selection, { id: area.id, name: area.name }]);
    }
    this.search = '';
  }
  remove(id: string): void { this.selectionChange.emit(this.selection.filter(area => area.id !== id)); }
}
